;(function () {
    // nav = [{
    //     title: {string},
    //     href: {string},
    //     isAct: {boolean}
    // }];

    // navPosition = 'center' || 'right'
    // disabled = true || false
    // showInqNav = true || false
    // inqIndex = 0 || 1 || 3

    function headCtrl() {
        var vm = this;

        this.$onChanges = bindingsOnChanges;

        var pending = false;
        !Array.isArray(vm.nav) && (vm.nav = []);
        vm.isOpened = DSSX.util.safe(DSSX, 'attr.state', '') === 'opened';
        vm.usrInfo = DSSX.currUser;
        vm.isPreviewMode = DSSX.util.safe(DSSX, 'attr.isPreviewMode', false);

        vm.changeState = function () {
            layer.open({
                title: '提示',
                content: vm.isOpened ? '是否重新体验国际站开通流程？' : '是否切换国际站至开通状态？',
                resize: false,
                move: false,
                btn: ['确定', '取消'],
                yes: function () {
                    if (pending) {
                        return;
                    }
                    var loadIdx = layer.load(2, {shade: 0.2});
                    pending = true;
                    DSSX.request.get('/usr/api/updateAccountState', {
                        state: vm.isOpened ? 6 : 7
                    }, true).then(function (rs) {
                        layer.msg('切换成功，正在刷新页面...');
                        location.href = '/';
                    }, function (err) {
                        DSSX.dialog.err(err, {
                            moduleName: 'headCtrl',
                            funcName: 'changeState',
                            text: 'changeState fail',
                        });
                        layer.close(loadIdx);
                    }).always(function () {
                        pending = false;
                    });
                }
            });
        };

        vm.logout = function () {
            DSSX.request.get(DSSX.host.protocol + '//' + DSSX.host.sso + '/sso/api/logout', {}, true)
                .then(function (rs) {
                    location.href = DSSX.host.protocol + '//' + DSSX.host.sso + '/sso/?url=' + encodeURIComponent(DSSX.host.protocol + '//' + DSSX.host.main);
                }, function (err) {
                    DSSX.dialog.err(err, {
                        moduleName: 'headCtrl',
                        funcName: 'logout',
                        text: 'logout fail',
                    });
                    layer.msg('注销登录失败');
                });
        }
        vm.linkTo = function() {
            if (DSSX.appProp.examType === 'xkz') {
                console.log('[headCtrl] xkz not support English Site')
                return
            }

            var params = location.search
            var path = location.pathname
            var host = DSSX.host.main_en
            var protocol = DSSX.host.protocol
            location.href = protocol + '//' + host + path + params
        }
        function bindingsOnChanges(changes) {
            if (changes.navPosition) {
                vm.navPosition = vm.navPosition || 'center';
            }

            if (changes.isGuideStatus) {
                vm.isGuideStatus = vm.isGuideStatus || false;
            }
        }
    }

    try {
        angular.module('DSSXAPP').component('dsHeader', {
            template:'<div><div class="ds-header clearfix"><div class="dh-nav" ng-show="vm.navPosition === \'center\'"><a ng-repeat="n in vm.nav track by $index" ng-href="{{n.href}}" ng-class="{\'dh-nav-active\': n.isAct, \'ds-index-bind-tip-event\': n.isBindingTipEvent}" ng-bind="n.title"></a></div><div class="dh-left"><a href="ali-index.html"><img src="/images/common/kuxiao.png"></a> <a href="/" class="my-alibaba">My Alibaba</a></div><div class="dh-right ng-cloak"><button ng-click="vm.changeState()" ng-bind="vm.isOpened ? \'体验国际站开通流程\' : \'切换国际站至开通状态\'" ng-hide="vm.isPreviewMode || vm.disabled" ng-class="{\'guide-status\': vm.isGuideStatus}"></button><div class="extra-cc" ng-show="vm.navPosition === \'right\'"><a class="item" ng-repeat="n in vm.nav track by $index" ng-href="{{n.href}}" ng-bind="n.title"></a></div><div><div class="dh-avatar"><img ng-src="{{vm.usrInfo.usr.attrs.basic.avatar || \'/imgs/user.png\'}}"></div><div class="dh-menu"><div><div><img ng-src="{{vm.usrInfo.usr.attrs.basic.avatar || \'/imgs/user.png\'}}"></div><div><div>你好，{{vm.usrInfo.usr.attrs.basic.nickName}}</div><a href="/account-center.html" ng-hide="vm.disabled">用户中心</a> <a ng-click="vm.logout()">退出</a></div></div><div>消息中心</div><div class="h-notify-item" style="cursor: not-allowed;"><a href="javascript:;">待处理订单</a> <a href="javascript:;">0</a></div><div class="h-notify-item"><a href="inquiry-manage.html">未读询盘</a> <a href="inquiry-manage.html">3</a></div><div class="h-notify-item" style="cursor: not-allowed;"><a href="javascript:;">未读人脉</a> <a href="javascript;;">0</a></div></div></div><span>卖家频道 <i class="iconfont icon-moreunfold" style="position: relative; top: 4px;"></i></span> <span ng-click="vm.linkTo()">简体中文 <i class="iconfont icon-moreunfold" style="position: relative; top: 4px;"></i></span> <span>保障中心</span></div></div><div ng-if="vm.showInqNav" class="ng-cloak"><div class="inq inquiry-nav-wrap"><div class="hover-warp f-l"><img src="images/data-admin/oms-menus-icon.png"><hover-nav-menu-left class="da-hnml"></hover-nav-menu-left></div><div class="f-l f-s14">商机管理中心(询盘)</div><ul id="nav-list" class="inq-ul"><li><a class="item" href="inquiry-manage.html" ng-class="{\'selected\': vm.inqIndex === \'0\'}">询盘</a></li><li><a class="item" href="client-manage.html" ng-class="{\'selected\': vm.inqIndex === \'1\'}">客户</a></li><li><a class="item">邮箱</a></li><li><a class="item" href="opportunity-management-set.html" ng-class="{\'selected\': vm.inqIndex === \'3\'}">设置</a></li></ul></div><div class="inq inquiry-tip"><span>【官方活动】用阿里卖家APP赢天猫精灵大奖！</span> <span>点击查看详情</span> <span>询盘百科全书</span></div></div></div>',
            bindings: {
                nav: '<',
                navPosition: '<',
                disabled: '<',
                showInqNav: '<',
                inqIndex: '<',
                isGuideStatus: '<'
            },
            controllerAs: 'vm',
            controller: headCtrl
        });
    } catch (e) {
        console.warn(e);
    }
    angular.module('DSSXAPPHeader', []).component('dsHeader', {
        template:'<div><div class="ds-header clearfix"><div class="dh-nav" ng-show="vm.navPosition === \'center\'"><a ng-repeat="n in vm.nav track by $index" ng-href="{{n.href}}" ng-class="{\'dh-nav-active\': n.isAct, \'ds-index-bind-tip-event\': n.isBindingTipEvent}" ng-bind="n.title"></a></div><div class="dh-left"><a href="ali-index.html"><img src="/images/common/kuxiao.png"></a> <a href="/" class="my-alibaba">My Alibaba</a></div><div class="dh-right ng-cloak"><button ng-click="vm.changeState()" ng-bind="vm.isOpened ? \'体验国际站开通流程\' : \'切换国际站至开通状态\'" ng-hide="vm.isPreviewMode || vm.disabled" ng-class="{\'guide-status\': vm.isGuideStatus}"></button><div class="extra-cc" ng-show="vm.navPosition === \'right\'"><a class="item" ng-repeat="n in vm.nav track by $index" ng-href="{{n.href}}" ng-bind="n.title"></a></div><div><div class="dh-avatar"><img ng-src="{{vm.usrInfo.usr.attrs.basic.avatar || \'/imgs/user.png\'}}"></div><div class="dh-menu"><div><div><img ng-src="{{vm.usrInfo.usr.attrs.basic.avatar || \'/imgs/user.png\'}}"></div><div><div>你好，{{vm.usrInfo.usr.attrs.basic.nickName}}</div><a href="/account-center.html" ng-hide="vm.disabled">用户中心</a> <a ng-click="vm.logout()">退出</a></div></div><div>消息中心</div><div class="h-notify-item" style="cursor: not-allowed;"><a href="javascript:;">待处理订单</a> <a href="javascript:;">0</a></div><div class="h-notify-item"><a href="inquiry-manage.html">未读询盘</a> <a href="inquiry-manage.html">3</a></div><div class="h-notify-item" style="cursor: not-allowed;"><a href="javascript:;">未读人脉</a> <a href="javascript;;">0</a></div></div></div><span>卖家频道 <i class="iconfont icon-moreunfold" style="position: relative; top: 4px;"></i></span> <span ng-click="vm.linkTo()">简体中文 <i class="iconfont icon-moreunfold" style="position: relative; top: 4px;"></i></span> <span>保障中心</span></div></div><div ng-if="vm.showInqNav" class="ng-cloak"><div class="inq inquiry-nav-wrap"><div class="hover-warp f-l"><img src="images/data-admin/oms-menus-icon.png"><hover-nav-menu-left class="da-hnml"></hover-nav-menu-left></div><div class="f-l f-s14">商机管理中心(询盘)</div><ul id="nav-list" class="inq-ul"><li><a class="item" href="inquiry-manage.html" ng-class="{\'selected\': vm.inqIndex === \'0\'}">询盘</a></li><li><a class="item" href="client-manage.html" ng-class="{\'selected\': vm.inqIndex === \'1\'}">客户</a></li><li><a class="item">邮箱</a></li><li><a class="item" href="opportunity-management-set.html" ng-class="{\'selected\': vm.inqIndex === \'3\'}">设置</a></li></ul></div><div class="inq inquiry-tip"><span>【官方活动】用阿里卖家APP赢天猫精灵大奖！</span> <span>点击查看详情</span> <span>询盘百科全书</span></div></div></div>',
        bindings: {
            nav: '<',
            navPosition: '<',
            disabled: '<',
            showInqNav: '<',
            inqIndex: '<',
            isGuideStatus: '<'
        },
        controllerAs: 'vm',
        controller: headCtrl
    });
    DSSX.loadHandler.New().onload = function () {
        $('[dsng-app]').each(function () {
            angular.bootstrap($(this), ['DSSXAPPHeader'])
        });
    }
})();
